module.exports = __webpack_public_path__ + "media/1_3-49.44d283e8.mp3";